export const SITE_SIPARIS_OZETI = {
  baslik: 'Site siparişleri ve tahsilatlar',
  aciklama: 'Web sitesinden CRM’e aktarılan son kayıtlar. Tutarlar siparişin kendi para birimindedir.',
  tumu: 'Tüm site siparişleri',
  denemeler: 'Ödeme denemelerini gör',
  tahsilatlar: 'Son 5 başarılı tahsilat',
  diger: 'Diğer son 5 sipariş',
  digerAciklama: 'Ödeme bekleyen, provizyondaki, iptal veya iade edilmiş siparişler.',
  hata: 'Site siparişleri yüklenemedi.',
  yukleniyor: 'Site siparişleri yükleniyor…',
  bosTahsilat: 'CRM’e aktarılmış başarılı tahsilat bulunmuyor.',
  bosDiger: 'Diğer durumda site siparişi bulunmuyor.',
  tahsilatTarihi: 'Tahsilat', siparisTarihi: 'Sipariş', bilinmiyor: 'Tarih kaydı yok',
  siparisTutari: 'Sipariş tutarı',
  durum: {
    PAID: 'Ödendi', PENDING_PAYMENT: 'Ödeme bekleniyor', AUTHORIZED: 'Provizyonda, tahsil edilmedi',
    CANCELLED: 'İptal edildi', REFUNDED: 'Tamamı iade edildi', PARTIALLY_REFUNDED: 'Kısmen iade edildi',
  },
} as const;
